import axios from "axios";
import jsPDF from "jspdf";
import { uri } from "../../help/Api";
import { sto } from "../../Context/InshData";
import * as _ from "lodash";
import { callAddFont } from "../amiri-font";
import { stElemnt } from "../../St/Reviews/cStyle";
import "./AFReadyDisigen/invoiceprint.css";
import { callAddBoldFontNew } from "../amiri-bold";
import { NotoArabicBold } from "../../components/invoice-generator/vfs_noto";


export const styleFooterNotesAr = {
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  fontWeight: "bold",
  direction: "rtl",
  fontFamily: "Amiri-Regular",
  textAlign: "right"
};
export const styleFooterNotesEn = {
  whiteSpace: 'pre-wrap',
  overflowWrap: 'break-word',
  fontWeight: "bold",
  direction: "ltr",
  fontFamily: "Amiri-Regular",
  textAlign: "left"
};
export const getInvData = async (setInv, proc_id) => {
  axios
    .get(uri + `InvForFatora?proc_id=${proc_id}`)
    .then((res) => {
      setInv(res.data);
    })
    .catch((error) => { });
};


export const mergColumns = (col1, col2) => {
  if (col2 != null && col2 != "") {
    return `${col1} \n ${col2}`
  } else {
    return `${col1}`
  }
};
export const getInfoInvPrint = async (locInv, setData, setSta, setFound, premiApp, omlat, empFound, setAppInv, foundData, setFoundData) => {
  const num = Number(premiApp.billTemplate);
  const tb = {
    GetFoundation: foundData?.found?.id > 0 ? false : !empFound,
    Rpt_Inv: true,
    wait: true,
    SettInvsApp: foundData?.found?.id > 0 ? false : setAppInv,
    omlat: foundData?.found?.id > 0 ? false : true,
    empFound: foundData?.found?.id > 0 ? false : empFound,
    stor: sto,
    parms: {
      lprocid: locInv.proc_id,
      ibranchid: locInv?.branchInv,
      branch: locInv?.branchInv,
      iFoundid: 1,
      sProcTypeInvProc: locInv.ProcTypeInvProc,
      iuserid: sto.idi,
    },
    autos: {},
  };
  await axios
    .post(`${uri}Res`, tb)
    .then((res) => {
      if (foundData?.found?.id > 0) {
        setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: foundData?.invSet ?? {}, omlat: foundData?.omlat ?? [] });
        setFound(foundData?.found);
      } else {
        setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: res.data.SettInvsApp, omlat: omlat ? res.data.omlats : {} });
        if (res?.data?.FoundData != null) {
          setFound(res.data.FoundData);
          setFoundData({ found: res.data.FoundData, invSet: res.data.SettInvsApp, omlat: omlat ? res.data.omlats : [] });
        } else {
          setFound(res.data.Found);
          setFoundData({ found: res.data.Found, invSet: res.data.SettInvsApp, omlat: omlat ? res.data.omlats : [] });
        }
      }

      const data = res.data.RptInv.map((row, i) => {
        return {
          ...row,
          no: i + 1,
          notesall: mergColumns(row.symbol, row.notes_details),
          nameEng: num === 16 ? row.nameEN : "",
          notesD: row.notes_details != "" && row.notes_details != null ? row.notes_details : row.symbol,
          symbol: num === 16 ? mergColumns(row.symbol, row.nameEN) :
            num !== 30 ? row.symbol : num === 18 && row.notes_details != "" && row.notes_details != null ? row.notes_details : row.symbol,
          totBill: new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(row.totBill),
          priceC: parseFloat(row.new_exchange_price).toFixed(2),
          new_exchange_price: locInv?.UseBefore == 1 ?
            row.exchange_price.toFixed(locInv?.NRound ?? 4) : row.new_exchange_price.toFixed(locInv?.NRound ?? 4),
          amountAfterDisc: new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(row.amountAfterDisc),
          netTotal: parseFloat(row.tot_net_curr).toFixed(2),
          tot_net_curr: new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(row?.tot_net_curr),
          discount: new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(row?.discount),
        };
      });
      setData(data);

    })
    .catch((error) => {
      console.log("catch");
    });
};

export const shareDataPdf = async (reportDownloadRef, nameFile) => {
  jsPDF.API.events.push(["addFonts", callAddFont]);
  var doc = new jsPDF("portrait", "pt", "a4");
  doc.setFont("Helvetica", "bold");
  let mfile;
  await doc.html(reportDownloadRef.current, {
    html2canvas: {
      width: 200,
      height: 297,
      scale: 0.75,
    },
    async callback(doc) {
      var blob = await doc.output("blob");
      mfile = new File([blob], nameFile, { type: blob.type });
    },
  });

  if (navigator.share && navigator.canShare({ files: [mfile] })) {
    await navigator.share({
      title: "",
      text: "",
      files: [mfile],
    });
  } else {
    alert("cant share files");
  }
}

export const handleDownloadGenratePdf = async (nameFile, reportDownloadRef) => {
  jsPDF.API.events.push(["addFonts", callAddFont]);
  var doc = new jsPDF("portrait", "pt", "a4");
  // doc.addFileToVFS("NotoSansArabic-Bold.ttf", NotoArabicBold);
  // doc.addFont('NotoSansArabic-Bold.ttf', 'NotoSansArabic', 'bold');
  doc.setFont("NotoSansArabic", "bold");
  doc.html(reportDownloadRef.current, {
    html2canvas: {
      width: 200,
      height: 297,
      scale: 0.75,
    },
    async callback(doc) {
      await doc.save(nameFile);
    },
  });
};
export const getInfoFound = async (setInfo, loodSta, setSta) => {
  const tb = {
    GetFoundation: true,
    SettInvsApp: loodSta,
    wait: true,
    parms: {
      iFoundid: 1, branch: sto.branchi, iuserid: sto.idi,
    },
    autos: {},
  };
  await axios
    .post(`${uri}Res`, tb)
    .then((res) => {
      setInfo(res.data.Found);
      if (loodSta) { setSta({ StngIA: res.data.SettInvsApp }); }
    })
    .catch((error) => {
      console.log("catch");
    });
};

export const styleContPrint = {
  backgroundImage: "linear-gradient(60deg, #4e9e84 , #2688ba)",
};

export const stylePaddingHead = { paddingRight: "4mm", paddingLeft: "4mm", paddingTop: "4mm", fontFamily: "Amiri-Regular" };
export const stylePaddingFooter = { paddingRight: "4mm", paddingLeft: "4mm", fontFamily: "Amiri-Regular", paddingBottom: "4mm" };
export const stylePadding = { paddingRight: "4mm", paddingLeft: "4mm", fontFamily: "Amiri-Regular" };
export const styleNo = { width: "5%", border: "solid 0.1px", padding: "0px 0px", textAlign: "-webkit-center", };
export const styleOthers = { width: "15%", border: "solid 0.1px", padding: "0px 0px", textAlign: "-webkit-center", };

export const cellSName = {
  width: "30%",
  maxWidth: "33%",
  padding: "0px 0px",
  textAlign: "-webkit-center",
  margin: "0px",
  whiteSpace: "normal",
  border: "solid 0.1px",
  fontSize: "10px",
  fontFamily: "Amiri-Regular",
  fontWeight: "bold",
};
export const WaterMarkImage = ({ found }) => {
  return (
    <div
      className="watermark-image">
      <img
        src={`data:image/jpeg;base64,${found.Logo}`}
        alt="Watermark"
      />
      <h1>{found.nameA}</h1>
    </div>

  );
};

export const WaterMarkName = ({ found }) => {
  return (
    <div
      className="watermark-image">
      <h1>{found.nameA}</h1>
    </div>

  );
};
export const getCellNameStyle = (value) => ({
  width: value?.length > 20 ? "25%" : "33%",
  padding: "0px 0px",
  textAlign: "-webkit-center",
  margin: "0px",
  whiteSpace: "normal",
  fontSize: "10px",
  fontFamily: "Amiri-Regular",
  fontWeight: "bold",
});
export const cellTStyle = {
  ...stElemnt.AF.cell,
  padding: "0px 1px",
}



